<template>
  <component :is="layout" :event="event" :entity-by-id="entityById" />
</template>

<script>
import { experienceEntityById } from '../../../data/reckon-way/entities';
import RetreatEventPage from '../layouts/RetreatEventPage.vue';
import ConferenceEventPage from '../layouts/ConferenceEventPage.vue';
import RecurringConferenceEventPage from '../layouts/RecurringConferenceEventPage.vue';
import HolidayPartyEventPage from '../layouts/HolidayPartyEventPage.vue';
import LocalEventPage from '../layouts/LocalEventPage.vue';

const LAYOUT_BY_TYPE = {
  retreat: RetreatEventPage,
  conference: ConferenceEventPage,
  'holiday-party': HolidayPartyEventPage,
  'local-event': LocalEventPage,
};

export default {
  name: 'EventRenderer',
  props: { event: { type: Object, required: true } },
  computed: {
    entityById() {
      return { ...experienceEntityById, ...(this.event.entityById || {}) };
    },
    layout() {
      if (this.event.eventType === 'conference' && this.event.recurring) {
        return RecurringConferenceEventPage;
      }

      return LAYOUT_BY_TYPE[this.event.eventType] || null;
    },
  },
};
</script>
